<template>
  <div>
    <vs-row>
      <vs-col vs-type="flex" vs-align="flex-end" vs-w="2">
        <span class="sdf-text-18-400-light-navy">現操作量</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="5">
        <span class="sdf-text-17-400-light-navy">ジョイスティック</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="5">
        <span class="sdf-text-17-400-light-navy">回頭ダイアル</span>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
        <joystick
          :forwardValue="currentJoystickOperationAmountForward"
          :rightValue="currentJoystickOperationAmountRight"
        />
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
        <turning-dial
          :value="currentTurningDialOperationAmountRight"
        ></turning-dial>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { isNumber } from "lodash";
import { ColorMixin, MappingTableMixin } from "@/mixins/addon/secure-dataflow";

// components
import Joystick from "./components/Joystick";
import TurningDial from "./components/TurningDial";

// Store
const {
  mapState: mapStateOfMonitoringVesselManeuvering
} = createNamespacedHelpers("sdfMonitoringVesselManeuvering");

export default {
  mixins: [ColorMixin, MappingTableMixin],
  components: {
    Joystick,
    TurningDial
  },
  data() {
    return {};
  },
  computed: {
    ...mapStateOfMonitoringVesselManeuvering({
      channelDataManeuvering: state => state.channelDataManeuvering
    }),
    currentJoystickOperationAmountForward() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB31.vn)) {
          return Number(this.channelDataManeuvering.SB31.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    currentJoystickOperationAmountRight() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB32.vn)) {
          return Number(this.channelDataManeuvering.SB32.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    currentTurningDialOperationAmountRight() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB33.vn)) {
          return Number(this.channelDataManeuvering.SB33.vn.toFixed(1));
        } else {
          return null;
        }
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss"></style>
